import { api as $axios } from '@/helpers/interceptors'
import {
  GET_BRANCH_LIST,
  CREATE_BRANCH,
  UPDATE_BRANCH,
  DELETE_BRANCH,
  GET_BRANCH_DETAIL,
  UPDATE_BRANCH_TIME,
  BRANCH_UPLOAD_EXCEL,
  UPDATE_BRANCH_TIME_ONLY,
} from '@/constants/path'
import { meta } from '@/config/pagination'
import snakeCaseKeys from 'snakecase-keys'

const setUnLoading = (commit, status = false) => {
  commit('SET_STATE', {
    key: 'isLoading',
    value: status,
  })
}
const initFilter = {
  page: 1,
  perPage: 15,
}
const state = () => ({
  data: [],
  qty: {},
  meta,
  isError: false,
  isLoading: false,
  form: {
    name: null,
    phone: null,
    address: null,
    branchCode: null,
    isBranchDeposit: false,
  },
  formTime: {
    id: undefined,
    date: null,
    time: null,
    quotaRemain: null,
    description: null,
    active: true,
    quotaLimit: null,
  },
  loadingUploadFile: false,
  filter: initFilter,
})

// getters
const getters = {}

// actions
const actions = {
  async getBranchList({ commit }, params) {
    setUnLoading(commit, true)
    try {
      const res = await $axios(
        `${GET_BRANCH_LIST}`,
        'get',
        snakeCaseKeys({ params }),
      )
      commit('SET_FORM', res?.data?.data?.branches?.data)
      commit('SET_STATE', {
        key: 'meta',
        value: {
          totalItemCurrentPage: res?.data?.data?.branches.total,
          itemPerPage: res?.data?.data?.branches.to,
          currentPage: res?.data?.data?.branches.currentPage,
          totalItem: res?.data?.data?.branches.total,
          totalPage: res?.data?.data?.branches.form,
        },
      })
      commit('SET_STATE', {
        key: 'qty',
        value: res?.data?.data?.qty || {},
      })
      setUnLoading(commit)
    } catch (error) {
      commit('SET_STATE', {
        key: 'meta',
        value: meta,
      })
      commit('SET_STATE', {
        key: 'data',
        value: [],
      })
      commit('SET_STATE', {
        kay: 'qty',
        value: {},
      })
      setUnLoading(commit)
    }
  },
  setDataSort({ commit }, data) {
    commit('SET_STATE', {
      key: 'data',
      value: data,
    })
  },
  async setForm({ commit }, id) {
    setUnLoading(commit, true)
    try {
      const res = await $axios(`${GET_BRANCH_DETAIL}/${id}`, 'get')
      commit('SET_STATE', {
        key: 'form',
        value: res?.data?.data,
      })
      setUnLoading(commit)
      return res?.data?.data
    } catch (error) {
      setUnLoading(commit)
    }
  },
  async createBranches(_, data) {
    await $axios(CREATE_BRANCH, 'post', data)
  },
  async updateBranches(_, data) {
    await $axios(`${UPDATE_BRANCH}/${data.id}`, 'put', data)
  },
  async updateBranchTime(_, data) {
    let map = JSON.parse(JSON.stringify(data))
    delete map.quota_limit
    delete map.quota_remain
    await $axios(UPDATE_BRANCH_TIME, 'post', map)
  },
  async updateBranchTimeOnly(_, data) {
    delete data.name
    await $axios(`${UPDATE_BRANCH_TIME_ONLY}/${data.id}`, 'put', data)
  },
  async deleteBranches(_, id) {
    await $axios(`${DELETE_BRANCH}/${id}`, 'delete')
  },
  async uploadExcel({ commit }, data) {
    try {
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: true,
      })
      await $axios(BRANCH_UPLOAD_EXCEL, 'post', data)
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: false,
      })
    } catch (error) {
      commit('SET_STATE', {
        key: 'loadingUploadFile',
        value: false,
      })
    }
  },
}

// mutations
const mutations = {
  SET_STATE(state, ops) {
    state[ops.key] = ops.value
  },
  SET_FORM(state, value) {
    value.forEach((item) => {
      item.isBranchDeposit = Boolean(Number(item.isBranchDeposit))
    })
    state.data = value
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
